import React from 'react';
import { Box, Tooltip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

type Props = {
  tip: React.ReactNode;
  children?: React.ReactNode;
  placement?: 'top' | 'bottom' | 'left' | 'right';
};

/**
 * Label + circled "i" icon. Hovering, focusing or tapping either the label or the icon shows `tip`.
 * Without children it renders the icon alone. Works inside TextField / Select labels, Tab labels and
 * FormControlLabel labels (pointer events are re-enabled because MUI input labels turn them off).
 */
const InfoTip: React.FC<Props> = ({ tip, children, placement = 'top' }) => (
  <Tooltip
    title={<Box component="span" sx={{ display: 'block', fontSize: 13, lineHeight: 1.45, maxWidth: 320 }}>{tip}</Box>}
    arrow
    placement={placement}
    enterTouchDelay={0}
    leaveTouchDelay={8000}
  >
    <Box
      component="span"
      sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5, cursor: 'help', pointerEvents: 'auto', verticalAlign: 'middle' }}
    >
      {children}
      <InfoOutlinedIcon
        aria-label="What is this?"
        sx={{ fontSize: '1.05em', color: 'info.main', opacity: 0.85, flexShrink: 0 }}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
      />
    </Box>
  </Tooltip>
);

export default InfoTip;
